<div class="home-container">
  <div class="flex justify-center">
    <img src="./assets/home.png" />
  </div>
  @if (!userAuthenticated) {
    <p-button label="Accedi" icon="fas fa-arrow-right-to-bracket" size="large" class="m-5" (click)="login()" />
  }
</div>
